import React, { Component } from "react";
import axios from "../../axios";
import Alert from "react-s-alert";
import FormDropdown from "../../components/FormDropdown";
import XLSX from 'xlsx'
import Dropzone from 'react-dropzone'
import { status_import_guru } from '../../constants/general'
import qs from 'qs'
import {convertAngkaKeHari} from "../../functions/functionGeneral";

const dataHari = []

for (let i=0; i<6; i++) {
    dataHari[i] = {
        key     : i + 1,
        value   : convertAngkaKeHari(i + 1)
    }
}

class ImportJadwal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            kelas_id: "",
            user_id: "",
            mapel_id: "",
            file: [],
            message:"",
            status_import_guru:"",
            dataKelas : [],
            dataMapel : [],
            dataGuru : [],
            dataGagal :[],
            isButtonLoading: false,
            isLoading: false,
            isModalVerifikasi  : false
        };

        this.handleChange = this.handleChange.bind(this);
        this.exportFile = this.exportFile.bind(this);
        this.toggleModalVerifikasi  = this.toggleModalVerifikasi.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    toggleModalVerifikasi() {

        this.setState({ isModalVerifikasi: !this.state.isModalVerifikasi})

    }

    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })
    }


    exportFile() {
        this.setState({ isButtonLoading: true });

        const wb = XLSX.utils.book_new()
        const sheet1 = XLSX.utils.table_to_sheet(document.getElementById('kelas'), {sheet:"Data Kelas"});
        const sheet2 = XLSX.utils.table_to_sheet(document.getElementById('mapel'), {sheet:"Data Mapel"});
        const sheet3 = XLSX.utils.table_to_sheet(document.getElementById('guru'), {sheet:"Data Guru"});
        const sheet4 = XLSX.utils.table_to_sheet(document.getElementById('hari'), {sheet:"Data Hari"});
        const sheet5 = XLSX.utils.table_to_sheet(document.getElementById('format'), {sheet:"Format Import Jadwal"});
        XLSX.utils.book_append_sheet(wb, sheet1, 'Data Kelas');
        XLSX.utils.book_append_sheet(wb, sheet2, 'Data Mapel');
        XLSX.utils.book_append_sheet(wb, sheet3, 'Data Guru');
        XLSX.utils.book_append_sheet(wb, sheet4, 'Data Hari');
        XLSX.utils.book_append_sheet(wb, sheet5, 'Format Import Jadwal');
        XLSX.writeFile(wb, "Format Import Jadwal.xlsx");

        this.setState({ isButtonLoading: false });
    }


    handleDeleteFile(index) {

        const copiedStateFiles = [
            ...this.state.file
        ]

        copiedStateFiles.splice(index, 1)

        this.setState({
            file: copiedStateFiles
        })
    }

    onDrop(files) {
        const newState = this.state.file.concat(files)
        this.setState({
            file: newState
        });
    }

    handleSubmit() {
        let formData = new FormData();
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        if ([]) {
            formData.append('file', this.state.file[0])
        }else{
            formData.append('file', '')
        }

        const url = "jadwal/importjadwalnew"

        this.setState({ isButtonLoading: true })

        axios.post(url, formData, config)
            .then(response => {
                const result = response.data;

                if (result.success) {
                    Alert.success(result.message)
                    this.props.history.replace("/jadwal")
                }
                else {
                    if (Array.isArray(result.message)) {

                        result.message.map(item => {
                            Alert.error(item)

                            return true
                        })
                    }
                    else {

                        if(result.data.length > 0){
                            this.setState({
                                dataGagal  : result.data,
                                message  : result.message,
                                isLoading  : false
                            },()=>{
                                this. toggleModalVerifikasi();
                            })
                            Alert.error(result.message)
                        }else{
                            this.setState({
                                dataGagal  : result.data,
                                message  : result.message,
                                isLoading  : false
                            },()=>{
                                this. toggleModalVerifikasi();
                            })
                            Alert.error(result.message)
                        }
                    }
                    this.setState({ isButtonLoading: false })
                }
            })

            .catch(error => {
                Alert.error("Gagal terhubung ke server!")
                this.setState({ isButtonLoading: false })
            })
    }

    loadKelas(){
        this.setState({ isLoading: true })

        // const params = qs.stringify({
        //     page: this.state.currentPage + 1
        // })

        axios({
            method: 'post',
            url: '/kelas?'
        })
            .then((response) => {

                const result = response.data

                if (result.success === true) {

                    this.setState({
                        dataKelas: result.data,
                        pageCount: result.data.last_page,
                        isLoading: false
                    })
                }
                else {

                    Alert.error(result.message)
                    this.setState({ isLoading: false })
                }
            })
            .catch((error) => {
                console.log(error)
                this.setState({ isLoading: false })
                Alert.error("Gagal terhubung ke server!")
            })
    }

    loadMapel(){
        this.setState({ isLoading: true })

        axios({
            method: 'post',
            url: '/mapel?'
        })
            .then((response) => {

                const result = response.data

                if (result.success === true) {
                    // console.log('consol ku ' + result.data.tugas.last_page)
                    this.setState({
                        dataMapel: result.data,
                        pageCount: result.data.last_page,
                        isLoading: false
                    })
                }
                else {

                    Alert.error(result.message)
                    this.setState({ isLoading: false })
                }
            })
            .catch((error) => {
                console.log(error)
                this.setState({ isLoading: false })
                Alert.error("Gagal terhubung ke server!")
            })
    }

    loadGuru(){
        this.setState({ isLoading: true })

        const params = qs.stringify({
            level: 'guru'
        });

        axios.post("/user?" + params)
            .then(response => {
                const result = response.data
                this.setState({
                    dataGuru  : result.data,
                    isLoading  : false
                })
            })
            .catch((error) => {
                console.log(error)
                this.setState({ isLoading: false })
                Alert.error("Gagal terhubung ke server!")
            })
    }

    componentDidMount() {
        this.loadMapel();
        this.loadKelas();
        this.loadGuru();
    }

    render() {
        return (
            <div className="col-sm-12">

                <div className="card" >
                    <div className="card-header">{this.props.mode} Form Import Data Jadwal</div>
                    <div className="card-block">
                        {this.state.isLoading ? (
                            "Memuat Data..."
                        ) : (
                            <div className="form-horizontal animated fadeIn">
                                <div className="form-group row">
                                    <div className="col-md-12">
                                        <div>
                                            <label className="col-md-12 form-control-label">
                                                <strong>*Generate excel format</strong><br/>
                                                <strong>*Pastikan file sesuai formatnya seperti yg anda generate</strong><br/>
                                            </label>
                                            <div className="form-group row">
                                                <label className="col-md-12 form-control-label">File Import</label>
                                                <div className="col-md-12">

                                                    <Dropzone
                                                        onDrop={this.onDrop.bind(this)}
                                                        style={{
                                                            width: "100%",
                                                            height: "auto",
                                                            border: "2px dashed #e9e9e9",
                                                            padding: "20px 30px",
                                                            color: "#888",
                                                            cursor: "pointer",
                                                            textAlign: "center",
                                                            marginBottom: "15px"
                                                        }}
                                                    >
                                                        Klik atau drop file disini untuk mengupload file
                                                    </Dropzone>

                                                    <ul>
                                                        {
                                                            this.state.file.map((item, index) =>
                                                                <li key={"file" + index} style={{ marginBottom: "10px" }}>
                                                                    {item.name} {" "}
                                                                    <button
                                                                        title="Hapus"
                                                                        className="btn btn-sm btn-danger"
                                                                        onClick={() => this.handleDeleteFile(index)}
                                                                        type="button"
                                                                    >
                                                                        <i className="fa fa-remove"></i>
                                                                    </button>
                                                                </li>
                                                            )
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <button
                                                    className="btn btn-primary"
                                                    disabled={this.state.isButtonLoading && "disabled"}
                                                    onClick={this.exportFile}>
                                                    {this.state.isButtonLoading ? "Loading" : "Generate Excel Format"}
                                                </button>{" "}
                                            </div>
                                            <div style={{ display:'none' }}>
                                                <table id="kelas" className="table table-striped animated fadeIn">
                                                    <thead>
                                                        <tr>
                                                            <th>No</th>
                                                            <th>Id Kelas</th>
                                                            <th>Nama Kelas</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.dataKelas.length > 0 ?
                                                                this.state.dataKelas.map((item, i)=>{
                                                                    return(
                                                                        <tr>
                                                                            <td>{i+1}</td>
                                                                            <td>{item.kelas_id}</td>
                                                                            <td>{item.kelas_nama}</td>
                                                                        </tr>
                                                                    )
                                                                })
                                                             : (
                                                                    <tr>
                                                                        <td colSpan={3}>Data Kelas Kosong</td>
                                                                    </tr>
                                                                )
                                                        }
                                                    </tbody>
                                                </table>
                                                <table id="mapel" className="table table-striped animated fadeIn">
                                                    <thead>
                                                    <tr>
                                                        <th>No</th>
                                                        <th>Id Mapel</th>
                                                        <th>Nama Mata Pelajaran</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        this.state.dataMapel.length > 0 ?
                                                            this.state.dataMapel.map((item, i)=>{
                                                                return(
                                                                    <tr>
                                                                        <td>{i+1}</td>
                                                                        <td>{item.mapel_id}</td>
                                                                        <td>{item.mapel_nama}</td>
                                                                    </tr>
                                                                )
                                                            })
                                                            : (
                                                                <tr>
                                                                    <td colSpan={3}>Data Mapel Kosong</td>
                                                                </tr>
                                                            )
                                                    }
                                                    </tbody>
                                                </table>
                                                <table id="guru" className="table table-striped animated fadeIn">
                                                    <thead>
                                                    <tr>
                                                        <th>No</th>
                                                        <th>Id Guru</th>
                                                        <th>Nama Guru</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        this.state.dataGuru.length > 0 ?
                                                            this.state.dataGuru.map((item, i)=>{
                                                                return(
                                                                    <tr>
                                                                        <td>{i+1}</td>
                                                                        <td>{item.user_id}</td>
                                                                        <td>{item.user_nama}</td>
                                                                    </tr>
                                                                )
                                                            })
                                                            : (
                                                                <tr>
                                                                    <td colSpan={3}>Data Guru Kosong</td>
                                                                </tr>
                                                            )
                                                    }
                                                    </tbody>
                                                </table>
                                                <table id="hari" className="table table-striped animated fadeIn">
                                                    <thead>
                                                    <tr>
                                                        <th>No</th>
                                                        <th>Id Hari</th>
                                                        <th>Nama Hari</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        dataHari.map((item, i)=>{
                                                            return(
                                                                <tr>
                                                                    <td>{i+1}</td>
                                                                    <td>{item.key}</td>
                                                                    <td>{item.value}</td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                    </tbody>
                                                </table>
                                                <table id="format" className="table table-striped animated fadeIn">
                                                <thead>
                                                    <tr>
                                                        <th>NO</th>
                                                        <th>NAMA KELAS</th>
                                                        <th>NAMA MAPEL</th>
                                                        <th>NAMA USER</th>
                                                        <th>HARI</th>
                                                        <th>JAM MULAI</th>
                                                        <th>JAM SELESAI</th>
                                                    </tr>
                                                </thead>
                                            </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="card-footer">


                        <button
                            type="button"
                            className="btn btn-md btn-primary"
                            disabled={this.state.isButtonLoading && "disabled"}
                            onClick={this.handleSubmit}
                        >
                            {this.state.isButtonLoading ? "Loading" : "Import"}
                        </button>{" "}
                        <button
                            type="button"
                            className="btn btn-md btn-danger"
                            disabled={this.state.isButtonLoading && "disabled"}
                            onClick={() => this.props.history.goBack()}
                        >
                            Batal
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ImportJadwal;



// WEBPACK FOOTER //
// ./src/views/Jadwal/ImportJadwal.js